import { enumButtonLabelPosition, enumElementBorderStyle } from "../constants";
import { QFAButton } from "../CoreApp/QFAButton";

export function AddFloatingViewerIconButton(
  parent,
  label,
  cmdCode,
  x,
  y,
  hoverCode,
  iconColor,
  fs,
  hoverColor
) {
  var button = new QFAButton();
  button.InitButton(parent, label, cmdCode, x, y, 23, 23, fs);
  button.SetBorderStyle(enumElementBorderStyle.noBorder);
  button.fLabelPosition = enumButtonLabelPosition.center;
  if (iconColor) button.SetFontColor(iconColor);
  if (hoverColor) button.SetHoverColor(hoverColor);
  if (hoverCode && hoverCode !== "") button.SetHoverCode(hoverCode);
  return button;
}
